import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { svgConfig } from '@/router/design-svg/constants';
import { ISvgInfo, Shape } from '@/router/design-svg/types';

export interface ISvgModel {
    svgConfig: ISvgInfo;
    curShape: Shape;
    setSvgConfig: (payload: ISvgInfo) => void;
    setCurShape: (payload: Shape) => void;
}

/** 管理 SVG 素材制作路由的画布配置与当前图形 */
export const useSvgModel = create<ISvgModel>()(
    immer((set) => ({
        svgConfig,
        setSvgConfig: (payload) =>
            set((state) => {
                state.svgConfig = payload;
            }),
        curShape: Object.keys(svgConfig)[0] as Shape,
        setCurShape: (payload) =>
            set((state) => {
                state.curShape = payload;
            }),
    })),
);

/**
 * 获取 SVG 素材制作状态
 *
 * @returns 当前 SVG Store 状态
 */
export const getSvgModel = () => useSvgModel.getState();
